import React from 'react'
import {Link} from 'react-router-dom'
import { FaSquareXTwitter } from "react-icons/fa6";
 
const DevotionalFooter = () => {
  return (
    <div className='devotional-footer'>
       <div className='container-fluid g-0'>
            <div className='row g-0'>
         <div className='col-12 col-sm-5'>
              <h1 className='devotional-footer-heading'>TeluguOneServices</h1>
              <div className='d-flex flex-wrap'>
                <div className='devotional-footer-links-container'>
                    <Link  target="_blank" rel="noreferrer" to="https://www.teluguone.com/movies">Movies</Link>
                    <Link  target="_blank" rel="noreferrer" to="https://www.teluguone.com/tmdb">Movie News</Link>
                    <Link  target="_blank" rel="noreferrer" to="https://www.teluguone.com/news">NEWS</Link>
                    <Link  target="_blank" rel="noreferrer" to="https://www.teluguoneradio.com">TORi(Radio)</Link>
                    <Link  target="_blank" rel="noreferrer" to="http://www.kidsone.in/">Kids One</Link>
                    <Link  target="_blank" rel="noreferrer" to="https://www.teluguone.com/comedy">Comedy</Link>
                </div>
                <div className='devotional-footer-links-container'>
                    <Link  target="_blank" rel="noreferrer" to="https://www.teluguone.com/videos">Videos</Link>
                    <Link  target="_blank" rel="noreferrer" to="https://www.teluguone.com/shortfilms">Short Films</Link>
                    <Link  target="_blank" rel="noreferrer" to="https://www.teluguone.com/toneshop">Send Gifts</Link>
                    <Link  target="_blank" rel="noreferrer" to="https://www.teluguone.com/tonegreetings">Greetings</Link>
                    <Link  target="_blank" rel="noreferrer" to="https://www.teluguone.com/photos">Photos</Link>
                    <Link  target="_blank" rel="noreferrer" to="https://www.teluguone.com/vanitha">Vanitha</Link>
                </div>
                <div className='devotional-footer-links-container'>
                    <Link  target="_blank" rel="noreferrer" to="https://www.teluguone.com/health">Health</Link>
                    <Link  target="_blank" rel="noreferrer" to="https://www.teluguone.com/toneastrology">Astrology</Link>
                    <Link  target="_blank" rel="noreferrer" to="https://www.teluguone.com/nri">NRI Corner</Link>
                    <Link  target="_blank" rel="noreferrer" to="https://www.teluguone.com/grandalayam">Grandalayam</Link>
                    <Link  target="_blank" rel="noreferrer" to="https://www.teluguone.com/recipes">Recipes</Link>
                    <Link  target="_blank" rel="noreferrer" to="https://www.teluguonefoundation.in/index.html">Charity</Link>
                </div>
              </div>
         </div> 
         <div className='col-6 col-sm-4 d-none d-sm-block'>
         <h1 className='devotional-footer-heading'>CustomerService</h1>
                <div className='d-flex devotional-footer-customer-care'>
                   <img src="/devotional/assets/images/customer_service_logo.jpg" alt="csl" />
                   <div>
                    <h3>LiveHelp24/7Customer Care</h3>
                    <Link  target="_blank" rel="noreferrer" to="mailto:teluguone.teluguone@gmail.com" >teluguone.teluguone@gmail.com</Link>
                    <h3>Send your Queries to</h3>
                    <Link  target="_blank" rel="noreferrer" to="mailto:support@teluguone.com" >support@teluguone.com</Link>
                     <Link  className='devotional-footer-about-link' target="_blank" rel="noreferrer" to="https://www.teluguone.com/helpdir/index.jsp?filename=/aboutus/aboutus.htm">About TeluguOne</Link>
                   </div>
                </div>
         </div> 
         <div className='col-6 col-sm-3 d-none d-sm-block'>
         <h1 className='devotional-footer-heading'>Follow Us Here</h1>
         <a className="devotional-footer-icon-anchor text-white" target="_blank" href="https://x.com/theteluguone" rel="noreferrer">
                     <FaSquareXTwitter  className="devotional-footer-anchor-icon"  />
                     <span>Follow @theteluguone</span>
                     </a>
         </div> 
         <div className='col-12 '><p className='devotional-footer-copyright'>Copyright © 2000 - {new Date().getFullYear()} TeluguOne.com All Rights Reserved</p></div>
         <div className='col-12'><p className='devotional-footer-copyright devotional-footer-disclaimer'>Disclaimer:
 All content on this website, including text, images, videos, graphics, and audio, is the intellectual property
  of ObjectOne Information Systems Ltd. and/or its affiliates. Any unauthorized reproduction, distribution, modification, 
  or publication of this material, in whole or in part, is strictly prohibited without
  prior written consent from ObjectOne Information Systems Ltd.</p></div>
            </div>
       </div>
    </div>
  )
}
 
export default DevotionalFooter;
